import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationLogoReplacementFailedAction = {
	type: 'ORGANIZATION_LOGO_REPLACEMENT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationLogoReplacementFailedAction => ({
	type: 'ORGANIZATION_LOGO_REPLACEMENT_FAILED',
	payload,
});
